<template>
  <v-card>
    <v-card-title class="justify-center">
      <h3>
        <span v-if="state === 'add'">Tambah</span>
        <span v-if="state === 'edit'">Ubah</span>
        <span v-if="state === 'detail'">Detail</span>
        Diagnosa
      </h3>
      <v-btn absolute right @click="onClose()" small icon>
        <v-icon> mdi-close </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row no-gutters justify="center">
          <v-col md="8">
            <v-form ref="form" lazy-validation>
              <div class="detail-input">
                <div class="detail-input__label">
                  <label
                    for="name"
                    :class="state !== 'detail' ? 'required' : ''"
                  >
                    Kode Diagnosa
                  </label>
                </div>

                <v-text-field
                  v-model="form.code"
                  placeholder="Masukkan Kode Diagnosa"
                  class="detail-input__input-text"
                  required
                  :readonly="state === 'detail'"
                  :rules="[v => !!v || 'Wajib diisi']"
                />
              </div>
              <div class="detail-input">
                <div class="detail-input__label">
                  <label
                    for="name"
                    :class="state !== 'detail' ? 'required' : ''"
                  >
                    Deskripsi Diagnosa
                  </label>
                </div>

                <v-textarea
                  v-model="form.description"
                  placeholder="Tambahkan Deskripsi Diagnosa"
                  class="detail-input__input-text"
                  name="deskripsidiagnosa"
                  outlined
                  height="200"
                  required
                  :readonly="state === 'detail'"
                  :rules="[v => !!v || 'Wajib diisi']"
                ></v-textarea>
              </div>
            </v-form>
          </v-col>
        </v-row>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="text-none" color="secondary" text @click="onClose()">
            Kembali
          </v-btn>
          <v-btn
            v-if="state !== 'detail'"
            depressed
            class="text-none"
            color="primary"
            @click="handleActionDiagnose()"
          >
            Simpan
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import Swal from 'sweetalert2';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapActions } = createNamespacedHelpers('MasterDiagnose');

export default {
  props: {
    state: {
      type: String,
      default: 'add',
    },
  },
  computed: {
    ...mapGetters(['getForm']),
    form: {
      get() {
        return this.getForm;
      },
    },
  },
  mounted() {
    if (this.state !== 'add') {
      this.resolveGetDiagnoseById();
    }
  },
  methods: {
    ...mapActions([
      'resolvePutDiagnose',
      'resolvePostDiagnose',
      'resolveGetDiagnoseById',
    ]),
    onClose() {
      this.$emit('close-dialog');
    },
    handleActionDiagnose() {
      if (!this.$refs.form.validate()) return;
      switch (this.state) {
        case 'add':
          this.resolvePostDiagnose().then(status => {
            if (status === 200) {
              Swal.fire('Berhasil', 'Data diagnosa sudah masuk', 'success');
            } else {
              Swal.fire('Gagal', 'Data diagnosa gagal ditambahkan', 'error');
            }
          });
          break;
        case 'edit':
          this.resolvePutDiagnose().then(status => {
            if (status === 200) {
              Swal.fire('Berhasil', 'Data diagnosa berhasil diubah', 'success');
            } else {
              Swal.fire('Gagal', 'Data diagnosa gagal diubah', 'error');
            }
          });
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-input {
  display: flex;
  align-items: baseline;
  justify-content: space-between;

  &__label {
    justify-content: flex-start;
    flex: 1;
    display: flex;
    color: #222;
  }

  &__input-text {
    margin-left: 10px;
    width: 150px;
  }
}

.required:after {
  content: ' *';
  color: red;
}
</style>
